var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-tabs', {
    attrs: {
      "vertical": "",
      "content-class": "col-12 col-md-9 mt-1 mt-md-0",
      "pills": "",
      "nav-wrapper-class": "col-md-3 col-12",
      "nav-class": "nav-left"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "UserIcon",
            "size": "18"
          }
        }), _c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Cofigurações Gerais")])];
      },
      proxy: true
    }])
  }, [_vm.options ? _c('account-setting-general', {
    attrs: {
      "general-data": _vm.options
    }
  }) : _vm._e()], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "LockIcon",
            "size": "18"
          }
        }), _c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Modificar Senha")])];
      },
      proxy: true
    }])
  }, [_c('account-setting-password')], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "InfoIcon",
            "size": "18"
          }
        }), _c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Informações")])];
      },
      proxy: true
    }])
  }, [_vm.options ? _c('account-setting-information', {
    attrs: {
      "information-data": _vm.options
    }
  }) : _vm._e()], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "CheckCircleIcon",
            "size": "18"
          }
        }), _c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Verificação")])];
      },
      proxy: true
    }])
  }, [_vm.options ? _c('account-setting-social', {
    attrs: {
      "social-data": _vm.options
    }
  }) : _vm._e()], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "BellIcon",
            "size": "18"
          }
        }), _c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Notificações")])];
      },
      proxy: true
    }])
  }, [_vm.options ? _c('account-setting-notification', {
    attrs: {
      "notification-data": _vm.options
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }